module.exports = __webpack_public_path__ + "img/2012-09-06 (FF 21) Montage Holzelemente.4594c4bc.jpg";